(function(){
  'use strict';

  function money(cents){
    try{ return (window.Shopify && Shopify.formatMoney) ? Shopify.formatMoney(cents) : '$'+(cents/100).toFixed(2); }
    catch(e){ return '$'+(cents/100).toFixed(2); }
  }

  // ---- FAQ accordion ----
  document.querySelectorAll('.q').forEach(function(q){
    q.addEventListener('click', function(){
      var a=q.querySelector('.a'), open=q.classList.contains('open');
      document.querySelectorAll('.q').forEach(function(x){ x.classList.remove('open'); var xa=x.querySelector('.a'); if(xa) xa.style.maxHeight=0; });
      if(!open){ q.classList.add('open'); if(a) a.style.maxHeight=a.scrollHeight+'px'; }
    });
  });

  // ---- Reserve countdown ----
  var cd=document.querySelector('[data-countdown]');
  if(cd){
    var target=new Date(cd.getAttribute('data-countdown')+'T00:00:00');
    var d=cd.querySelector('[data-d]'),h=cd.querySelector('[data-h]'),m=cd.querySelector('[data-m]');
    function tick(){
      var t=target-new Date();
      if(isNaN(t)||t<0){ if(d)d.textContent='00'; if(h)h.textContent='00'; if(m)m.textContent='00'; return; }
      if(d)d.textContent=String(Math.floor(t/864e5)).padStart(2,'0');
      if(h)h.textContent=String(Math.floor(t/36e5)%24).padStart(2,'0');
      if(m)m.textContent=String(Math.floor(t/6e4)%60).padStart(2,'0');
    }
    tick(); setInterval(tick,1000);
  }

  // ---- Details modal ----
  var modal=document.querySelector('[data-modal]');
  var modalCardIdx=null;
  function openModal(card){
    if(!modal) return;
    modalCardIdx=card;
    var img=modal.querySelector('[data-mimg]');
    var src=card.getAttribute('data-img');
    if(src){ img.src=src; img.style.display='block'; } else { img.style.display='none'; }
    modal.querySelector('[data-mtitle]').textContent=card.getAttribute('data-name')||'';
    modal.querySelector('[data-mdesc]').textContent=card.getAttribute('data-desc')||'';
    var al=card.getAttribute('data-allerg');
    modal.querySelector('[data-mallerg]').textContent=al?('Contains '+al):'';
    modal.classList.add('on');
  }
  function closeModal(){ if(modal) modal.classList.remove('on'); }
  if(modal){
    modal.addEventListener('click',function(e){ if(e.target===modal || e.target.hasAttribute('data-close')) closeModal(); });
  }

  // ---- Product gallery: click thumb to swap, click main to zoom ----
  var mainImg=document.querySelector('[data-main-image]');
  if(mainImg){
    var lb=document.querySelector('[data-lightbox]');
    var lbImg=lb?lb.querySelector('[data-lightbox-img]'):null;
    document.querySelectorAll('.thumb').forEach(function(t){
      t.addEventListener('click',function(){
        var swap=t.getAttribute('data-swap');
        if(swap){ mainImg.src=swap; mainImg.setAttribute('data-zoom', t.getAttribute('data-full')||swap); }
        document.querySelectorAll('.thumb').forEach(function(x){ x.classList.remove('sel'); });
        t.classList.add('sel');
      });
    });
    mainImg.addEventListener('click',function(){
      if(lb&&lbImg){ lbImg.src=mainImg.getAttribute('data-zoom')||mainImg.src; lb.classList.add('on'); }
    });
    if(lb) lb.addEventListener('click',function(){ lb.classList.remove('on'); });
    document.addEventListener('keydown',function(e){ if(e.key==='Escape'&&lb) lb.classList.remove('on'); });
  }

  // ---- Box builder ----
  var bb=document.querySelector('[data-boxbuilder]');
  if(bb){
    var sizeBtns=Array.prototype.slice.call(bb.querySelectorAll('.sizebtn'));
    var cards=Array.prototype.slice.call(bb.querySelectorAll('[data-flavour]'));
    var baysWrap=bb.querySelector('[data-bays]');
    var warn=bb.querySelector('[data-warn]');
    var selOut=bb.querySelector('[data-selected]');
    var sizeLabel=bb.querySelector('[data-sizelabel]');
    var sizeHint=bb.querySelector('[data-sizehint]');
    var totOut=bb.querySelector('[data-total]');
    var addBtn=bb.querySelector('[data-addbox]');
    var counts=cards.map(function(){ return 0; });
    var required=0, variantId=null, priceCents=0, bays=[];

    function total(){ return counts.reduce(function(a,b){return a+b;},0); }

    function buildBays(){
      baysWrap.innerHTML=''; bays=[];
      for(var i=0;i<required;i++){
        var b=document.createElement('div'); b.className='bay';
        b.innerHTML='<img alt="" style="display:none"><svg viewBox="0 0 100 100"><use href="#fl-rose"></use></svg>';
        baysWrap.appendChild(b); bays.push(b);
      }
    }

    function render(){
      var t=total();
      cards.forEach(function(c,i){
        c.querySelector('[data-count]').textContent=counts[i];
        c.querySelector('[data-inc]').disabled=(required===0)||(t>=required);
        c.querySelector('[data-dec]').disabled=counts[i]===0;
        c.classList.toggle('has',counts[i]>0);
      });
      var glyphs=[], pics=[];
      cards.forEach(function(c,i){ for(var k=0;k<counts[i];k++){ glyphs.push(c.getAttribute('data-glyph')||'rose'); pics.push(c.getAttribute('data-img')||''); } });
      bays.forEach(function(bay,i){
        var im=bay.querySelector('img'), sv=bay.querySelector('svg');
        if(i<glyphs.length){
          bay.classList.add('full');
          if(pics[i]){ im.src=pics[i]; im.style.display='block'; if(sv) sv.style.display='none'; }
          else { im.style.display='none'; if(sv){ sv.style.display='block'; sv.querySelector('use').setAttribute('href','#fl-'+glyphs[i]); } }
        } else {
          bay.classList.remove('full'); if(im) im.style.display='none';
        }
      });
      selOut.textContent=required?(t+' / '+required):'0';
      if(required===0){ warn.textContent='Choose a box size to begin.'; warn.style.color='var(--grey)'; }
      else if(t<required){ warn.textContent=(required-t)+' more to fill your '+required+'-box. Any mix — all of one is fine.'; warn.style.color='var(--gold-dk)'; }
      else { warn.textContent='Box complete.'; warn.style.color='var(--wine)'; }
      addBtn.disabled=(required===0)||(t!==required);
    }

    function selectSize(btn){
      sizeBtns.forEach(function(b){ b.classList.remove('sel'); });
      btn.classList.add('sel');
      required=parseInt(btn.getAttribute('data-size'),10)||0;
      variantId=btn.getAttribute('data-vid');
      priceCents=parseInt(btn.getAttribute('data-price'),10)||0;
      counts=cards.map(function(){ return 0; });
      sizeLabel.textContent=required+' cookies';
      totOut.textContent=money(priceCents);
      if(sizeHint) sizeHint.textContent='Fill your box with exactly '+required+' cookies — any combination of the six.';
      buildBays(); render();
    }

    sizeBtns.forEach(function(btn){ btn.addEventListener('click',function(){ selectSize(btn); }); });
    cards.forEach(function(c,i){
      c.querySelector('[data-inc]').addEventListener('click',function(){ if(required && total()<required){ counts[i]++; render(); } });
      c.querySelector('[data-dec]').addEventListener('click',function(){ if(counts[i]>0){ counts[i]--; render(); } });
      c.querySelectorAll('[data-open]').forEach(function(el){ el.addEventListener('click',function(){ openModal(c); }); });
    });

    // modal "Add to Box" adds one of the opened cookie
    if(modal){
      var madd=modal.querySelector('[data-madd]');
      if(madd) madd.addEventListener('click',function(){
        if(modalCardIdx && required && total()<required){
          var i=cards.indexOf(modalCardIdx);
          if(i>=0){ counts[i]++; render(); }
        }
        closeModal();
      });
    }

    addBtn.addEventListener('click',function(){
      if(required===0 || total()!==required || !variantId) return;
      var selection=cards.filter(function(c,i){ return counts[i]>0; })
        .map(function(c){ var i=cards.indexOf(c); return counts[i]+' × '+c.getAttribute('data-name'); }).join(', ');
      addBtn.disabled=true; addBtn.textContent='Adding…';
      fetch('/cart/add.js',{
        method:'POST', headers:{'Content-Type':'application/json'},
        body:JSON.stringify({ items:[{ id:parseInt(variantId,10), quantity:1,
          properties:{ 'Box':required+' cookies', 'Your selection':selection } }] })
      }).then(function(r){ return r.json().then(function(data){ return { ok:r.ok, data:data }; }); })
        .then(function(res){
          if(res.ok){ window.location.href='/cart'; return; }
          addBtn.disabled=false; addBtn.textContent='Add Box to Cart';
          var msg=(res.data && (res.data.description||res.data.message))||'Could not add to cart.';
          alert(msg+'\n\nTip: open the "Build a Box" product and turn OFF inventory tracking (or allow selling when out of stock), and make sure it is published to Online Store.');
        })
        .catch(function(){ addBtn.disabled=false; addBtn.textContent='Add Box to Cart';
          alert('Could not reach the cart. Check your connection and that the Box product is published.'); });
    });

    render();
  }
})();
